import React from 'react';
import './Security.css';

const Security: React.FC = () => {
  return (
    <section className="security-section">
      <div className="security-container">
        <h2 className="security-title">Tu privacidad es nuestra prioridad 🔒</h2>
        <p className="security-subtitle">
          Gestiona tus finanzas con total tranquilidad y seguridad
        </p>

        <div className="security-features">
          <div className="security-card">
            <div className="security-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3>Cifrado de extremo a extremo</h3>
            <p>
              Todos tus datos sensibles están <strong>100% cifrados</strong> con los más altos estándares de seguridad.
              Ni siquiera nosotros podemos acceder a tu información financiera.
            </p>
          </div>

          <div className="security-card">
            <div className="security-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" />
                <path d="M9 9L15 15M15 9L9 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <h3>Sin conexión bancaria</h3>
            <p>
              <strong>No nos conectamos a tu banco</strong>. Tú decides qué información compartir y tienes
              control total sobre tus datos. Tu privacidad no es negociable.
            </p>
          </div>

          <div className="security-card">
            <div className="security-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" />
                <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" stroke="currentColor" strokeWidth="2" />
              </svg>
            </div>
            <h3>Transparencia total</h3>
            <p>
              Tus datos son tuyos. Puedes eliminarlos cuando quieras.
              Sin letra pequeña, sin sorpresas.
            </p>
          </div>
        </div>

        <div className="security-badges">
          <div className="badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Datos cifrados AES-256</span>
          </div>
          <div className="badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Sin acceso bancario</span>
          </div>
          <div className="badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>GDPR Compliant</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security;
